<div class="iframe-dialog-container">
  <h3 mat-dialog-title>
    {{data.subject}}
  </h3>
  
  <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px" >
    <p class="mr-4">Campaign: {{data.campaignName}}</p>
    <mat-icon class="time-icon" matTooltip="Time replied">schedule</mat-icon>
    <div class="replied-time">
      {{data.timestamp | date: 'medium'}}
    </div>
  </div>
  <mat-dialog-content>
    <!-- Loading skeleton -->
    <div *ngIf="isLoading" class="skeleton-container">
      <ngx-skeleton-loader 
        count="1"
        [theme]="{ 
          height: '600px',
          marginBottom: '0',
          backgroundColor: '#f5f5f5'
        }">
      </ngx-skeleton-loader>
    </div>

    <!-- Error message -->
    <div *ngIf="error" class="error-container">
      <mat-icon color="warn">error</mat-icon>
      <p>{{error}}</p>
      <button mat-raised-button color="primary" (click)="loadCampaignEmail()">
        Retry
      </button>
    </div>

    <!-- Iframe - Test cherry pick loop 2  -->
    <iframe 
      *ngIf="!isLoading && !error"
      [src]="iframeUrl | trustedSafeHtml:'resourceUrl'"
      frameborder="0"
      (load)="onIframeLoad()"
      class="campaign-iframe">
    </iframe>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close (click)="onClose()">Close</button>
  </mat-dialog-actions>
</div> 